const SINGLE_POST_UNIQUE_VIEWS_URL = `${BASE_URL}/members/api/member/uniqueBlogsPageviewsForMember`;
const MIN_UNIQUE_VIEWS_VALUE = 10;
const SLUG_DATA_ATTRIBUTE = 'data-slug';

const getUniquePostViews = async () => {

  const slugContainer = document.querySelector(`[${SLUG_DATA_ATTRIBUTE}]`);

  if (!slugContainer) {
    return null;
  }

  const postSlug = slugContainer.getAttribute(SLUG_DATA_ATTRIBUTE);

  const uniquePostViewsQueryString = `${SINGLE_POST_UNIQUE_VIEWS_URL}?slug=${postSlug}`;
  try {
    const response = await fetch(uniquePostViewsQueryString);
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
    return null;
  } catch (error) {
    console.error(error);
    return null;
  }
}

const showUniquePostViews = async () => {

  const uniqueViews = await getUniquePostViews();

  if (uniqueViews) {

    const uniqueViewsAmount = uniqueViews?.unique_blogs_pageviews[0].unique_pageviews;
    const isValidViewsAmount = typeof uniqueViewsAmount === 'number' && uniqueViewsAmount >= MIN_UNIQUE_VIEWS_VALUE;

    if (isValidViewsAmount) {

      const singlePostUniqueViewsContainer = document.querySelector('.single-post-page-views');
      singlePostUniqueViewsContainer.style.display = 'block';

      const uniqueViewsElement = document.querySelector('#single-post-unique-views');
      uniqueViewsElement.textContent = uniqueViewsAmount;

    }
  }
}